import React, {useState, useEffect, useRef, useCallback} from "react";
import {useCart} from '../cart/cart-utils'
import Counter from '../layouts/Counter';
import classNames from 'classnames';
import {API_ENDPOINT, useStateCallback} from '../components/config/Common'

const AddToCart = (props) => {
   const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty} = useCart();
   const [quantity, setQuantity] = useStateCallback(0)
   const [inCart, setInCart] = useState(false)
   const [invoice] = useState(localStorage.getItem('rand_num'));
   const outOfStock = false

   
   useEffect(() => {
      checkItemInCart(props.item.p_id)
      /* setQuantity(
         props.quantity,
         (s) => {
            setInCart(s <= 0 ? false : true)
            setQuantity(s)
         }  
      ) */
   },[props.quantity])

   const addToCart = () => {
      const qty = Number(quantity) + 1
      setQuantity(qty)
		
		setTimeout(() => {
         setInCart(true)
      }, 500);
      addCartItem(props.item)
	}

   const handleRemoveClick = async () => {
      console.log('itemCartQty', itemCartQty)
      let q = itemCartQty - 1;
      if(q <= 0){
         deleteCartItem(props.item.p_id)
      }else{
         updateItemQty(props.item.p_id, q)   
      }
   }
   const handleIncrement = () => {
      //console.log('Increment')
      updateItemQty(props.item.p_id, Number(itemCartQty)+1)
   }
   
   return (
      <>
      {
         itemCartQty <= 0
         ?
         <button className={classNames("flex w-full items-center justify-center rounded bg-accent py-4 px-5 text-sm font-semibold text-light transition-colors duration-300 hover:bg-accent-hover focus:bg-accent-hover focus:outline-none lg:text-base animate__animated",{'animate__flipOutX':itemCartQty >= 1 ? true : false, 'animate__flipInX':itemCartQty <= 0 ? true : false})} onClick={addToCart}>
            <span>Add To Shopping Cart</span>
         </button>
         :										
         <Counter
            value={itemCartQty}
            onDecrement={handleRemoveClick}
            onIncrement={handleIncrement}
            variant="big"
            disabled={outOfStock}
            className={classNames("animate__animated",{'animate__flipInX':itemCartQty >= 1 ? true : false, 'animate__flipOutX': itemCartQty <= 0 ? true : false})}
         />
      }
      </>
   )
}

export default AddToCart;